import { HashAnchor } from 'components/HashAnchor';
import FormGroup from 'components/shared/FormGroup';
import InputTextArea from 'components/shared/InputTextarea';
import { Controller, useFormContext } from 'react-hook-form';
import { FormTextareaProps } from './FormTextarea.types';

export const FormTextarea: React.FC<FormTextareaProps> = ({
  name,
  formGroup = {},
  input = {
    rows: 5
  }
}) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  const onChangeHandler =
    input.onChange ||
    (() => {
      // NOOP
    });

  return (
    <FormGroup
      {...formGroup}
      error={errors?.[name]?.message?.toString()}
      forId={name}
    >
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <HashAnchor name={`anchor_${name}`} />
            <InputTextArea
              variant={errors?.[name] ? 'error' : ''}
              {...input}
              id={name}
              {...field}
              onChange={(e) => {
                field.onChange(e);
                onChangeHandler(e);
              }}
            />
          </>
        )}
      />
    </FormGroup>
  );
};
